import React from "react";
import { CardHeader } from "../../../../../components/cards";
import { PriceGraph } from "../../../../scans/components/graphs";
import { Loading } from "../../../../../components";

interface IProductPriceVariations {
  data: any;
  loading: boolean;
}

export const ProductPriceVariations: React.FC<IProductPriceVariations> = ({
  loading,
  data,
}) => {
  return (
    <>
      {loading ? <Loading /> : null}
      {data ? <PriceGraph data={data} /> : null}
    </>
  );
};
